/**
 * Recurring Payment Response Codes
 * refer to https://developer.vodapay.vodacom.co.za/self-service/docs/Payment%20Flow/Response%20Codes for more details
 */
export default {
  SUCCESS: '00',
  CANCELLED: '17',
  SUS_FRAUD: '59',
};
